export function channelsMapper(apps: ApplicationResponseModel[], userId: string) {
  // Some roles (e.g. School.Admin) can receive apps they aren't explicitly a member of.
  // Filter to only the apps that include the user in `members`.
  return apps.flatMap((channel) => {
    const { members, ...forwardedProps } = channel;
    const user = members?.find((member) => member.id === userId);

    if (!user) return [];

    return [{ level: user.level, ...forwardedProps }];
  });
}
